import { base } from "../base";

async function addNew(data) {
  return base.post("catalogs/items", data);
}

async function update(data) {
  return base.put("catalogs/items", data);
}

async function getList(data) {
  const { results_per_page } = data
  if (!results_per_page) {
    data.results_per_page = 10000
  }
  return base.get("catalogs/items", data);
}

async function getPriceList(data) {
  return base.get("catalogs/price-list", data);
}

async function updatePriceList(data) {
  return base.put("catalogs/price-list", data);
}

async function getListItemUnderStock(data) {
  return base.get('stokers/dashboard/items-under-stock', data)
}

async function importItem(data) {
  return base.post('catalogs/items', data)
}

async function getListItemThreshold() {
  return base.get('trademarks/dashboard/inventory-detail')
}

async function getListItemType(data) {
  return base.get("catalogs/items-type", data);
}

async function combineOrderByItem(data) {
  return base.post('stokers/orders/combination', data)
}

async function combineOrderByItemInventory(data) {
  return base.post('stokers/orders/combination?include_inventory=True', data)
}

async function verifyChangeUnit(data) {
  return base.post("catalogs/items/verify-change-unit", data);
}

async function getListUnitByItem(params){
  return base.get('catalogs/units', params)
}

async function getPriceByItemUnit(params){
  return base.get('catalogs/get-valid-price', params)
}


export const itemService = {
  addNew,
  update,
  getList,
  getPriceList,
  updatePriceList,
  getListItemUnderStock,
  importItem,
  getListItemThreshold,
  getListItemType,
  combineOrderByItem,
  combineOrderByItemInventory,
  verifyChangeUnit,
  getListUnitByItem,
  getPriceByItemUnit
};
